import { IComment } from '@lib/core/comments/types';

export const isCommentExists = (comment: IComment, productId: string): boolean => comment?.product === productId;
